import styled from 'styled-components/native';

export default styled.Text`
  color: ${({ theme }) => theme.colors.primaryInactive};
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 40px;
  z-index: -1;
`;
